export enum AnnouncementStatus {
  New = 'New',
  Viewed = 'Viewed',
  Closed = 'Closed',
}
